const buttonKeys = {
  ivaResolution: 'ivaResolution',
  complaintMedia: 'complaintMedia',
};

const IVA_STATUS_MAPPING = {
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  REASSIGNED: 'Reassigned',
  TIMEOUT: 'Timeout',
};

const baseSectionClass = `tw-flex tw-items-center tw-rounded-2xl tw-bg-grey-100/70 tw-border tw-border-grey-200 tw-duration-500 tw-ease-in-out tw-mx-4 tw-transition-all tw-border tw-border-1 tw-border-solid tw-border-grey-200 tw-mb-4`;

const headerBtnStyles = (currentSelectedComponent, key) => {
  return `tw-text-[1.4rem] tw-flex tw-items-center tw-gap-2 tw-font-medium tw-bg-green-500/30 tw-border-solid tw-border-[2px] tw-border-green-500/80 tw-text-white tw-rounded-xl tw-px-6 tw-py-2 tw-leading-none tw-cursor-pointer hover:tw-bg-green-500/20 tw-transition-all tw-duration-200 tw-ease-in-out active:tw-scale-95
  ${
    currentSelectedComponent === key
      ? '!tw-border-white tw-outline-none tw-ring-2 tw-ring-grey-100/30'
      : ''
  } 
 `;
};

const IVARowStyles =
  'tw-p-3 tw-bg-blue-200 tw-text-grey-800  tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300 tw-text-center tw-whitespace-nowrap';

const resoRowStyles =
  'tw-px-2 tw-py-1 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200';

export {
  buttonKeys,
  IVA_STATUS_MAPPING,
  baseSectionClass,
  headerBtnStyles,
  IVARowStyles,
  resoRowStyles,
};
